import React from "react";
import maintain from '../assets/maintain.png'
const Maintenance = () => {
  return (
    <div
      style={{
        backgroundColor: "#ADD8E6", // light blue
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px"
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "30px",
          maxWidth: "600px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
        }}
      >
        {/* <h2 style={{ marginBottom: "20px" }}><strong>Maintenance</strong></h2> */}
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
          Dear MOMO User,
          <br />
          We wish to inform you that the MOMO app will undergo
          scheduled maintenance on Monday at 9:00 PM NST. During this
          period, our services may be briefly unavailable.
          <br />
          <br />
          This planned maintenance is part of our ongoing commitment to provide you
          with a faster, smoother, and more reliable experience on the MOMO
          platform.
          <br />
          <br />
          We appreciate your patience and understanding, and we look forward to
          welcoming you back online shortly after the update.
          <br />
          <br />
          Thank you for being part of the MOMO community.
          <br />
          <em>Warm regards,</em>
          <br />
          Team MOMO | Music Nepal
        </p>

        {/* Add your image here */}
        <img
           src = {maintain}
          alt="Maintenance"
          style={{ marginTop: "20px", maxWidth: "100%", borderRadius: "12px" }}
        />
      </div>
    </div>
  );
};

export default Maintenance;
